// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Command: MarkdocTagRegistration = {
  tag: 'command',
  component: 'Command',
  selfClosing: true,
  attributes: {
    text: {
      type: String,
      required: true,
    },
  },
};
